import {
    encodedArrayCodec,
    PresetSearchParamsCustomDefaultValues,
    withModeCodec,
} from "@impero-com/ui/domain";

export const PUSH_REPORTS_RESPONSIBLE_TABLE_STATE_STORAGE_KEY =
    "userPushReportsResponsibleList";

export const PUSH_REPORTS_RESPONSIBLE_LIST_COLUMN_IDS = {
    CUSTOM_REPORT_NAME: "customReportName",
    PUSH_REPORT_NAME: "pushReportName",
    TYPE: "type",
    FREQUENCY: "frequency",
    RECIPIENTS: "recipients",
} as const;

export const pushReportsResponsibleListTableDefaultValues: PresetSearchParamsCustomDefaultValues =
    {
        sorting: [
            {
                id: PUSH_REPORTS_RESPONSIBLE_LIST_COLUMN_IDS.CUSTOM_REPORT_NAME,
                desc: false,
            },
        ],
    };

export const pushReportsResponsibleListColumnFiltersCodecMap = {
    [PUSH_REPORTS_RESPONSIBLE_LIST_COLUMN_IDS.CUSTOM_REPORT_NAME]:
        withModeCodec(encodedArrayCodec),
    [PUSH_REPORTS_RESPONSIBLE_LIST_COLUMN_IDS.PUSH_REPORT_NAME]:
        withModeCodec(encodedArrayCodec),
    [PUSH_REPORTS_RESPONSIBLE_LIST_COLUMN_IDS.TYPE]:
        withModeCodec(encodedArrayCodec),
    [PUSH_REPORTS_RESPONSIBLE_LIST_COLUMN_IDS.FREQUENCY]:
        withModeCodec(encodedArrayCodec),
};
